/* ============================================
   TRADUCCIONES ESPAÑOLAS
   ============================================ */

export const es = {
  // Estados del partido
  matchStates: {
    notStarted: 'No comenzado',
    firstHalf: '1er tiempo',
    halfTime: 'Descanso',
    secondHalf: '2º tiempo',
    extraTimeFirstHalf: 'Prórroga 1er tiempo',
    extraTimeHalfTime: 'Descanso prórroga',
    extraTimeSecondHalf: 'Prórroga 2º tiempo',
    penalties: 'Penales',
    finished: 'Finalizado',
    postponed: 'Pospuesto',
    cancelled: 'Cancelado',
    interrupted: 'Interrumpido',
  },

  // Eventos
  events: {
    goal: 'Gol',
    yellowCard: 'Tarjeta amarilla',
    redCard: 'Tarjeta roja',
    substitution: 'Sustitución',
    corner: 'Córner',
    freeKick: 'Tiro libre',
    penalty: 'Penalti',
    offside: 'Fuera de juego',
    injury: 'Lesión',
    var: 'VAR',
    shotOnTarget: 'Tiro a puerta',
    shotOffTarget: 'Tiro fuera',
    throwin: 'Saque de banda',
    dangerousAttack: 'Ataque peligroso',
    attack: 'Ataque',
    possession: 'Posesión',
    sixMeters: 'Área de 6 metros',
    goalKick: 'Saque de meta',
    blockedShot: 'Tiro bloqueado',
    penaltyUnconfirmed: 'Penalti (sin confirmar)',
    penaltyMissed: 'Penalti fallado',
    goalNotification: 'Notificación de gol',
    kickoff: 'Saque inicial',
    secondHalfKickoff: 'Saque inicial 2° tiempo',
    ballLost: 'Balón perdido',
    ballRecovered: 'Balón recuperado',
    ownGoal: 'Gol en propia puerta',
    matchStart: 'Inicio',
    matchEnd: 'Fin',
    halfTimeScore: 'Resultado descanso',
    cardConfirmed: 'Tarjeta confirmada',
    extraTimeEnded: 'Prórroga terminada',
    penaltyEnded: 'Penalti terminado',
    penaltyShootout: 'Tanda de penales',
    penaltyShootoutMissed: 'Penal fallado (tanda)',
  },

  // Indicadores de posesión
  possession: {
    home: 'Posesión local',
    away: 'Posesión visitante',
    attack: 'Ataque',
    dangerousAttack: 'Ataque peligroso',
  },

  // Interfaz
  ui: {
    home: 'Local',
    away: 'Visitante',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    loading: 'Cargando...',
    noMatch: 'Ningún partido seleccionado',
    selectMatch: 'Seleccionar partido',
  },

  // Tiempo añadido
  addedTime: {
    label: 'Tiempo añadido',
    minute: 'min',
    minutes: 'min',
  },

  // Notificaciones
  notifications: {
    matchStarted: 'Inicio del partido',
    matchEnded: 'El partido ha terminado',
    halfTimeStarted: 'Descanso',
    secondHalfStarted: 'Reanudación del partido',
    matchAboutToStart: 'El partido va a comenzar',
    matchAboutToResume: 'El partido va a reanudarse',
    penaltiesInProgress: 'La tanda está en curso',
    // Notificaciones de eventos centrados
    kickoffTitle: 'Saque inicial',
    kickoffSubtitle: '¡El partido ha comenzado!',
    goalTitle: '¡Gol! ¡gol! ¡gol!',
    yellowCardTitle: 'Tarjeta amarilla',
    yellowCardSubtitle: 'Un jugador recibió una tarjeta amarilla',
    redCardTitle: 'Tarjeta roja',
    redCardSubtitle: 'Un jugador recibió una tarjeta roja',
    injuryTitle: 'Lesión',
    injurySubtitle: 'Un jugador está lesionado',
    substitutionTitle: 'Sustitución',
    substitutionSubtitle: 'Cambio en curso',
    varTitle: 'VAR en curso',
    varSubtitle: 'El árbitro tomará una decisión',
    varCancelledTitle: 'Gol anulado',
    varCancelledSubtitle: 'El gol fue anulado por el VAR',
    addedTimeTitle: 'Tiempo añadido',
    addedTimeSubtitle: '¡Se jugarán minutos adicionales!',
  },

  // Indicadores de campo (MAYÚSCULAS)
  fieldIndicators: {
    possession: 'POSESIÓN',
    attack: 'ATAQUE',
    dangerousAttack: 'ATAQUE PELIGROSO',
    throwin: 'SAQUE DE BANDA',
    freeKick: 'TIRO LIBRE',
    dangerousFreeKick: 'TIRO LIBRE PELIGROSO',
    corner: 'CÓRNER',
    goalKick: 'SAQUE DE META',
    penalty: 'PENALTI',
    shotOnTarget: 'TIRO A PUERTA',
    shotOffTarget: 'TIRO FUERA',
    offside: 'FUERA DE JUEGO',
    ballLost: 'BALÓN PERDIDO',
  },

  // Cuenta atrás
  countdown: {
    hours: 'H',
    minutes: 'MIN',
    seconds: 'SEG',
  },

  // Controles
  controls: {
    openRadar: 'Abrir Radar',
    reload: 'Recargar',
    date: 'Fecha',
    match: 'Partido',
    delay: 'Retraso (segundos)',
    fieldLength: 'Largo (px)',
    fieldWidth: 'Ancho (px)',
    fieldColor: 'Color del campo',
    language: 'Idioma',
    connectedStatus: 'Conectado',
    disconnectedStatus: 'Desconectado',
  },
};

